export enum FreezeWeekGraphqlErrorCode {
  ClassRoomAlreadyBookedInWeek = "CLASS_ROOM_ALREADY_BOOKED_IN_WEEK",
}
